Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("header")) {
        const header = new Vue({
            el: '#header',
            store,
            data: function () {
                return {
                    scrolled: false
                }
            },
            computed: {
                menuExpanded: {
                    get: function () {
                        return this.$store.getters.menuExpanded
                    },
                    set: function (newValue) {
                        this.$store.dispatch('toggleMenu', newValue)
                    }
                }
            },
            mounted: function () {
                this.resetExpandedMenu();
            },
            methods: {
                resetExpandedMenu: function () {
                    this.menuExpanded = false;
                },
                toggleMenu: function () {
                    this.menuExpanded = !this.menuExpanded;
                    document.body.classList.toggle('body--overflowHidden');
                }
            },
            created: function () {
            },
            destroyed: function () {
            }
        });
    }
});